import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/database';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAErlPx3VCXe9q9jLUn59nGrNze83zU1Jk",
  authDomain: "ies-evento.firebaseapp.com",
  databaseURL: "https://ies-evento-default-rtdb.firebaseio.com",
  projectId: "ies-evento",
  storageBucket: "ies-evento.firebasestorage.app",
  messagingSenderId: "1089236883753",
  appId: "1:1089236883753:web:2d662cd916faceca20ff38",
  measurementId: "G-7QYZ43GK67"
};

// 🔥 IMPORTANTE
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

class Firebase {

  constructor(){
    this.app = firebase;
    this.conexion = firebase.database();
  }

  obtener_webinars_usuario = (url, campo, valor, funct) => {
    this.conexion.ref(url).once('value', (objetos) => {

      if (this.collectionToArr(objetos).length > 0) {

        let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
          return objeto[campo] === valor;
        });

        if(objeto_buscado.length > 0){
          return funct(objeto_buscado[0]);
        }else{
          return funct(null);
        }
      }
      return funct(null);
    })
  }

  obtener_objeto = (url, campo, valor, funct) => {
    this.conexion.ref(url).once('value', (objetos) => {

      if (this.collectionToArr(objetos).length > 0) {

        let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
          return objeto[campo] === valor;
        });

        if(objeto_buscado.length > 0){
          return funct(objeto_buscado[0]);
        }else{
          const datos_objeto = {};
          datos_objeto[campo] = valor;
          this.escribir(url, undefined, datos_objeto, funct);
        }
      } else {
        const datos_objeto = {};
        datos_objeto[campo] = valor;
        this.escribir(url, undefined, datos_objeto, funct);
      }
    });
  }

  verificar_objeto = (url, campo, valor, funct) => {
    this.conexion.ref(url).once('value', (objetos) => {

      if (this.collectionToArr(objetos).length > 0) {

        let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
          return objeto[campo] === valor;
        });

        funct(objeto_buscado.length > 0);
      } else {
        funct(false);
      }
    });
  }

  escribir = (url, id, objeto, funct) => {
    let key = '';

    if (id === undefined) {
      key = this.conexion.ref(url).push().key;
    } else {
      key = id;
    }

    this.conexion.ref(url).child(key).set(objeto, () => {
      objeto['key'] = key;
      return funct(objeto);
    });
  }

  obtener_objetos = (url, escuchar ,funct) => {

    if(escuchar){
      this.conexion.ref(url).orderByChild("num_pregunta").on('value', (objetos) => {
        return funct(this.collectionToArr(objetos));
      })
    }else{
      this.conexion.ref(url).orderByChild("num_pregunta").once('value', (objetos) => {
        return funct(this.collectionToArr(objetos));
      })
    }
  }

  obtener_parametro = (url, escuchar ,funct) => {

    if(escuchar){
      this.conexion.ref(url).on('value', (parametro) => {
        return funct(parametro);
      })
    }else{
      this.conexion.ref(url).once('value', (parametro) => {
        return funct(parametro);
      })
    }
  }

  collectionToArr = (collection) => {
    var rows = [];
    if (collection && collection.val()) {

      collection.forEach((obj) => {
        let item = obj.val();
        item.key = obj.key;
        rows.push(item);
      });
    }
    return rows;
  }

  verificar_objeto_dia = (url, campo, valor, dia, funct) => {
    this.conexion.ref(url).once('value', (objetos) => {

      if (this.collectionToArr(objetos).length > 0) {

        let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
          return objeto[campo] === valor && dia === objeto['dia'];
        });

        funct(objeto_buscado.length > 0);
      } else {
        funct(false);
      }
    });
  }

}

export default Firebase;